import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const ExpiryDropdown = ({ isReadOnly = false, onChange, onFocus, onBlur, expiryMonthYear }) => {
    const { t } = useTranslation();

    const yearsToRender = [];
    const currentDate = new Date().getFullYear();
    for (let i = 0; i < 25; i++) {
        yearsToRender.push(currentDate + i);
    }

    const [month, setValidityMonth] = React.useState('');
    const [year, setValidityYear] = React.useState('');
    const [isDirty, setDirty] = React.useState(false);

    React.useEffect(() => {
        if (isDirty) {
            onChange({
                month: parseInt(month),
                year: parseInt(year)
            });
        }
    }, [month, year, onChange, isDirty]);

    React.useEffect(() => {
        if (expiryMonthYear) {
            setValidityYear(expiryMonthYear.year);
            setValidityMonth(parseInt(expiryMonthYear.month));
        } else {
            setValidityYear('');
            setValidityMonth('');
        }
    }, [expiryMonthYear]);

    return (
        <>
            <label>{t('expiryLabel')}</label>
            <div className="wz-lyriapay-payline-formblock-expiry">
                <select
                    id="ccmonth"
                    name="ccmonth"
                    autoComplete="cc-exp-month"
                    required
                    type="text"
                    placeholder={t('expiryMonthPlaceholder')}
                    disabled={isReadOnly}
                    value={month}
                    onBlur={() => onBlur()}
                    onFocus={() => onFocus()}
                    onChange={e => {
                        setDirty(true);
                        setValidityMonth(e.target.value);
                    }}
                    aria-required
                >
                    <option value="">{t('expiryMonthPlaceholder')}</option>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(i => {
                        return (
                            <option key={i} value={i}>
                                {i}
                            </option>
                        );
                    })}
                </select>
                <select
                    id="ccyear"
                    name="ccyear"
                    autoComplete="cc-exp-year"
                    required
                    type="text"
                    placeholder={t('expiryYearPlaceholder')}
                    disabled={isReadOnly}
                    value={year}
                    onBlur={() => onBlur()}
                    onFocus={() => onFocus()}
                    onChange={e => {
                        setDirty(true);
                        setValidityYear(e.target.value);
                    }}
                    aria-required
                >
                    <option value="">{t('expiryYearPlaceholder')}</option>
                    {yearsToRender.map(i => {
                        return (
                            <option key={i} value={i}>
                                {i}
                            </option>
                        );
                    })}
                </select>
            </div>
        </>
    );
};

ExpiryDropdown.propTypes = {
    isReadOnly: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    expiryMonthYear: PropTypes.object
};

export default ExpiryDropdown;
